import {
  GET_MANAGER_COMPLAINTS,
  GET_MANAGER_COMPLAINTS_FAILED,
  GET_MANAGER_COMPLAINTS_SUCCESS,
  GET_MANAGER_COMPLAINT_DETAIL,
  GET_MANAGER_COMPLAINT_DETAIL_FAILED,
  GET_MANAGER_COMPLAINT_DETAIL_SUCCESS,
  RESOLVE_MANAGER_COMPLAINT,
  RESOLVE_MANAGER_COMPLAINT_SUCCESS,
  RESOLVE_MANAGER_COMPLAINT_FAILED,
  REJECT_MANAGER_COMPLAINT,
  REJECT_MANAGER_COMPLAINT_SUCCESS,
  REJECT_MANAGER_COMPLAINT_FAILED,
  CLEAR_MANAGER_COMPLAINT_DETAIL,
} from './actionTypes';

const initialState = {
  isLoadingGetManagerComplaints: false,
  managerComplaints: [],
  totalManagerComplaints: 0,
  isLoadingGetManagerComplaintDetail: false,
  managerComplaintDetail: null,
  isLoadingResolveManagerComplaint: false,
  isLoadingRejectManagerComplaint: false,
};

export default function ManagerComplaint(state = initialState, action) {
  switch (action.type) {
    case GET_MANAGER_COMPLAINTS:
      return {
        ...state,
        isLoadingGetManagerComplaints: true,
      };

    case GET_MANAGER_COMPLAINTS_SUCCESS:
      return {
        ...state,
        isLoadingGetManagerComplaints: false,
        managerComplaints: action.payload?.data || [],
        totalManagerComplaints: action.payload?.total || 0,
      };

    case GET_MANAGER_COMPLAINTS_FAILED:
      return {
        ...state,
        isLoadingGetManagerComplaints: false,
      };

    case GET_MANAGER_COMPLAINT_DETAIL:
      return {
        ...state,
        isLoadingGetManagerComplaintDetail: true,
      };

    case GET_MANAGER_COMPLAINT_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetManagerComplaintDetail: false,
        managerComplaintDetail: action.payload,
      };

    case GET_MANAGER_COMPLAINT_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetManagerComplaintDetail: false,
      };

    case RESOLVE_MANAGER_COMPLAINT:
      return {
        ...state,
        isLoadingResolveManagerComplaint: true,
      };

    case RESOLVE_MANAGER_COMPLAINT_SUCCESS:
      return {
        ...state,
        isLoadingResolveManagerComplaint: false,
      };

    case RESOLVE_MANAGER_COMPLAINT_FAILED:
      return {
        ...state,
        isLoadingResolveManagerComplaint: false,
      };

    case REJECT_MANAGER_COMPLAINT:
      return {
        ...state,
        isLoadingRejectManagerComplaint: true,
      };

    case REJECT_MANAGER_COMPLAINT_SUCCESS:
      return {
        ...state,
        isLoadingRejectManagerComplaint: false,
      };

    case REJECT_MANAGER_COMPLAINT_FAILED:
      return {
        ...state,
        isLoadingRejectManagerComplaint: false,
      };

    case CLEAR_MANAGER_COMPLAINT_DETAIL:
      return {
        ...state,
        managerComplaintDetail: null,
      };

    default:
      return state;
  }
}
